/* eslint-disable react/jsx-pascal-case */
import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Icon } from "@iconify/react";
import { Divider } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import "./DashboardTicket.css";
import BarChart_CategoryResult from "./BarChart_CategoryResult";
import BarChart_TicketClosed from "./BarChart_TicketClosed";
import PieChart_TicketToday from "./PieChart_TicketToday";
import { SeverityPill } from "./SeverityPill";
import Loader from "../Components/Loader";
import { ReactComponent as LegendACW } from "../Images/LegendACW.svg";
import { ReactComponent as LegendAUX } from "../Images/LegendAUX.svg";

import {
  getDataChat,
  getHDDataCall,
  getHDDataTicket,
  getHDAgentState,
  getHDDataAgentMonitoring,
  getHDDepartmentTicket,
  getHDTicketCategoryResult,
  getHDTicketTodaySummary,
  getHDTicketClosed,
} from "../Store/Actions/DashboardAction";

export default function DashboardTicket() {
  const [statusCount, setStatusCount] = useState({});
  const [data, setData] = useState([]);
  const [callData, setCallData] = useState({});
  const [categoryResultData, setCategoryResultData] = useState([]);
  const [chatData, setChatData] = useState({});
  const [summaryTicketTodayData, setSummaryTicketTodayData] = useState([]);
  const [ticketData, setTicketData] = useState({});
  const [ticketClosedData, setTicketClosedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isCallLoading, setIsCallLoading] = useState(true);
  const [isChatLoading, setIsChatLoading] = useState(true);
  const [isTicketLoading, setIsTicketLoading] = useState(true);
  const [isAgentSummaryLoading, setIsAgentSummaryLoading] = useState(true);
  const [isDepartmentLoading, setIsDepartmentLoading] = useState(true);
  const [agentSummaryData, setAgentSummaryData] = useState(null);
  const [departmentData, setDepartmentData] = useState([]);

  useEffect(() => {
    const fetchData = () => {
      getHDAgentState()
        .then((response) => {
          if (response.status) {
            setData(response.data);
            setStatusCount(countAgentStatus(response?.data));
          } else {
            console.log("error", response.error);
          }

          setIsLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsLoading(false);
        });

      getHDDataAgentMonitoring()
        .then((response) => {
          if (response.status) {
            setAgentSummaryData(response.data);
          } else {
            console.log("error", response.error);
          }

          setIsAgentSummaryLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsAgentSummaryLoading(false);
        });
    };

    // Fetch data on first render
    fetchData();

    // Fetch data every ten seconds
    const interval = setInterval(() => {
      fetchData();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchData = () => {
      getHDDataCall()
        .then((response) => {
          if (response.status) {
            console.log("Call data: ", response.data);
            setCallData(response.data);
          } else {
            console.log("error", response.error);
          }
          setIsCallLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsCallLoading(false);
        });
    };

    // Fetch data on first render
    fetchData();

    // Fetch data every ten seconds
    const interval = setInterval(() => {
      fetchData();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchData = () => {
      setIsChatLoading(true);
      setIsTicketLoading(true);

      getDataChat()
        .then((response) => {
          if (response.status) {
            console.log("Chat data: ", response.data);
            setChatData(response.data);
          } else {
            console.log("error", response.error);
          }
          setIsChatLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsChatLoading(false);
        });

      getHDDataTicket()
        .then((response) => {
          if (response.status) {
            console.log("Ticket data: ", response.data);
            setTicketData(response.data);
          } else {
            console.log("error", response.error);
          }
          setIsTicketLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsTicketLoading(false);
        });

      getHDTicketClosed()
        .then((response) => {
          if (response.status) {
            console.log("Ticket closed data: ", response.data);
            setTicketClosedData(response.data);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });

      getHDTicketCategoryResult()
        .then((response) => {
          if (response.status) {
            console.log("Ticket category result data: ", response.data);
            setCategoryResultData(response.data);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });

      getHDTicketTodaySummary()
        .then((response) => {
          if (response.status) {
            console.log("Ticket today summary data: ", response.data);
            setSummaryTicketTodayData(response.data);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    };

    // Fetch data on first render
    fetchData();

    // Fetch data every 30 seconds
    const interval = setInterval(() => {
      fetchData();
    }, 1000 * 30);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getHDDepartmentTicket()
      .then((response) => {
        if (response.status) {
          console.log("Department data: ", response.data);
          setDepartmentData(response.data);
        } else {
          console.log("error", response.error);
        }
        setIsDepartmentLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setIsDepartmentLoading(false);
      });
  }, []);

  const dataACDAgents = {
    labels: ["Ready", "Busy", "ACW", "AUX", "Offline"],

    datasets: [
      {
        data: Object.values(statusCount),

        backgroundColor: [
          "#00FF00",
          "#FF0000",
          "#FFE900",
          "#EE7314",
          "#727272",
        ],
      },
    ],
  };

  const optionsACDAgents = {
    maintainAspectRatio: false,
    responsive: true,

    plugins: {
      datalabels: {
        font: {
          size: 16,
          weight: 700,
        },

        color: (context) => {
          return context.dataset.backgroundColor[context.dataIndex] ===
            "#00FF00" ||
            context.dataset.backgroundColor[context.dataIndex] === "#FFE900"
            ? "#393939"
            : "#FFF";
        },

        display: (context) => context.dataset.data[context.dataIndex] > 0,

        formatter: (value) => {
          const totalAgents = data.reduce(
            (sum, item) => sum + item.AgentCount,
            0
          );

          const countPercentage = (value, total) =>
            Math.round((100 * value) / total);

          return countPercentage(value, totalAgents) + "%";
        },
      },

      legend: {
        display: false,
      },
    },
  };

  const columnsACDAgents = [
    {
      field: "AgentName",
      flex: 1.5,
      headerName: "Agent Name",
    },

    {
      field: "CurrentState",
      flex: 1,
      headerName: "Status",
      minWidth: 135,

      renderCell: (params) => (
        <SeverityPill color={params.row.CurrentState.toLowerCase()}>
          {params.row.CurrentState}
        </SeverityPill>
      ),
    },

    {
      field: "Ext",
      flex: 1,
      headerName: "Ext",
    },

    {
      field: "AHT",
      flex: 1,
      headerName: "AHT",
      renderCell: (params) =>
        Math.round((params.row.AHT + Number.EPSILON) * 100) / 100,
    },

    {
      field: "CallsOffered",
      flex: 1,
      headerName: "Calls Offered",
    },

    {
      field: "CallsAnswered",
      flex: 1,
      headerName: "Calls Answered",
      minWidth: 140,
    },

    {
      field: "CallsAbandoned",
      flex: 1,
      headerName: "Abandoned",
    },

    {
      field: "GhostCalls",
      flex: 1,
      headerName: "Ghost Call",
    },

    {
      field: "ActiveTicket",
      flex: 1,
      headerName: "Active Ticket",
    },
  ];

  const countAgentStatus = (data) => {
    return {
      ready: data[3]?.AgentCount,
      busy: data[1]?.AgentCount,
      acw: data[2]?.AgentCount,
      aux: data[0]?.AgentCount,
      loggedOff: data[4]?.AgentCount,
    };
  };

  Chart.register(ChartDataLabels);

  let datalabels = {
    color: function (ctx) {
      var bgColor = ctx.dataset.backgroundColor[ctx.dataIndex];
      return bgColor === "#D9D9D9" || bgColor === "#aaaaaa" ? "black" : "white";
    },
    textShadowColor: function (ctx) {
      var bgColor = ctx.dataset.backgroundColor[ctx.dataIndex];
      return bgColor === "#D9D9D9" || bgColor === "#aaaaaa" ? "white" : "black";
    },
    textShadowBlur: 15,
    display: function (context) {
      return context.dataset.data[context.dataIndex] > 0;
    },
    font: {
      weight: "bold",
      size: 15,
    },
    formatter: Math.round,
  };

  return (
    <div className="dashboard-ticket">
      <div className="list_header">
        <div className="list_headerLeft">
          <h1>Ticket</h1>
        </div>
      </div>

      <div className="container-dashboard-ticket">
        <div className="new-dashboard">
          <section className="cards">
            <div className="item calls">
              <Icon className="icon" height="40" icon="material-symbols:call" />

              {isCallLoading ? (
                <Loader />
              ) : (
                <>
                  <div>
                    <p className="title">Active Calls</p>

                    <p className="value">
                      {callData ? callData?.total?.TotalActive : 0}
                    </p>
                  </div>

                  <div>
                    <p className="title">Total Calls</p>

                    <p className="value">
                      {callData ? callData?.total?.TotalCalls : 0}
                    </p>
                  </div>
                </>
              )}
            </div>

            <div className="item chats">
              <Icon className="icon" height="40" icon="mdi:message-group" />

              {isChatLoading ? (
                <Loader />
              ) : (
                <>
                  <div>
                    <p className="title">Active Chats</p>
                    <p className="value">{chatData.total.Active}</p>
                  </div>

                  <div>
                    <p className="title">Total Chats</p>
                    <p className="value">{chatData.total.TotalChat}</p>
                  </div>
                </>
              )}
            </div>

            <div className="item tickets">
              <Icon className="icon" height="40" icon="iconamoon:ticket-fill" />

              {isTicketLoading ? (
                <Loader />
              ) : (
                <>
                  <div>
                    <p className="title">Active Tickets</p>

                    <p className="value">
                      {ticketData ? ticketData?.total?.TotalActive : 0}
                    </p>
                  </div>

                  <div>
                    <p className="title">Total Tickets</p>

                    <p className="value">
                      {ticketData ? ticketData?.total?.TotalTicket : 0}
                    </p>
                  </div>
                </>
              )}
            </div>

            <div className="item tickets fcr">
              <Icon className="icon" height="40" icon="iconamoon:ticket-fill" />

              {isTicketLoading ? (
                <Loader />
              ) : (
                <>
                  <div>
                    <p className="title">FCR Tickets Today</p>

                    <p className="value">
                      {ticketData ? ticketData?.total?.FCRToday : 0}
                    </p>
                  </div>

                  <div>
                    <p className="title">N-FCR Tickets Today</p>

                    <p className="value">
                      {ticketData ? ticketData?.total?.NFCRToday : 0}
                    </p>
                  </div>
                </>
              )}
            </div>
          </section>

          <section className="agents-detail">
            <div className="agents-chart">
              <header>
                <div className="title">
                  <Icon height="26" icon="pajamas:status-health" />
                  Online Status
                </div>

                <p className="count">
                  {data.reduce((sum, item) => sum + item.AgentCount, 0)}
                </p>
              </header>

              <div className="chart-container">
                <Doughnut
                  data={dataACDAgents}
                  options={optionsACDAgents}
                  plugins={[ChartDataLabels]}
                />
              </div>

              <div className="agents-chart-legend">
                <div className="ready">
                  <Icon
                    height="26"
                    icon="tabler:square-rounded-check"
                    width="26"
                  />

                  <span>Ready</span>
                  <span className="count">{statusCount.ready}</span>
                </div>

                <div className="busy">
                  <Icon
                    height="26"
                    icon="tabler:alert-square-rounded-filled"
                    width="26"
                  />

                  <span>Busy</span>
                  <span className="count">{statusCount.busy}</span>
                </div>

                <div className="acw">
                  <LegendACW />
                  <span>ACW</span>
                  <span className="count">{statusCount.acw}</span>
                </div>

                <div className="aux">
                  <LegendAUX />
                  <span>AUX</span>
                  <span className="count">{statusCount.aux}</span>
                </div>

                <div className="not-bound">
                  <Icon height="26" icon="tabler:square-rounded-x" width="26" />

                  <span>Offline</span>
                  <span className="count">{statusCount.loggedOff}</span>
                </div>
              </div>
            </div>

            <div className="acd-agents">
              <header>
                <div className="title">
                  <Icon height="26" icon="ic:round-support-agent" width="26" />

                  <p>Agents Summary</p>
                </div>
              </header>

              <div className="table-container">
                <DataGrid
                  className="table"
                  columns={columnsACDAgents}
                  disableColumnFilter
                  disableColumnMenu
                  disableSelectionOnClick
                  hideFooter
                  loading={isAgentSummaryLoading}
                  rows={agentSummaryData?.acdagentDetail ?? []}
                  getRowId={(row) => row.AgentName + "-" + row.Ext}
                />
              </div>
            </div>
          </section>

          <section className="channel-list">
            <header>
              <div className="title">
                <Icon
                  height="26"
                  icon="fluent:bubble-multiple-20-filled"
                  width="26"
                />

                <p>Department List</p>
              </div>
            </header>

            <div className="list-container">
              {isDepartmentLoading ? (
                <Loader />
              ) : (
                departmentData.map((channel, index) => (
                  <div className="channel-item facebook" key={index}>
                    <div className="channel-content">
                      <p className="channel-details">{channel.Department}</p>

                      <div className="channel-data">
                        {Object.entries(channel)
                          .slice(1)
                          .map(([key, value]) => (
                            <div className="channel-data-item" key={key}>
                              <p className="key">{key}</p>
                              <p className="value">{value}</p>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </section>

          <section className="agents-detail">
            <div className="item save-result">
              <header>
                <div className="title">Category Result Today</div>
              </header>

              <Divider />

              <BarChart_CategoryResult
                categoryResult={categoryResultData}
                datalabels={datalabels}
              />
            </div>
          </section>

          <section className="agents-detail">
            <div className="item assignment-solved">
              <header>
                <div className="title">Ticket Closed</div>
              </header>

              <Divider />

              <BarChart_TicketClosed
                ticketClosed={ticketClosedData}
                datalabels={datalabels}
              />
            </div>

            <div className="item solved-status">
              <header>
                <div className="title">Ticket Status Today</div>
              </header>

              <Divider />

              <PieChart_TicketToday
                ticketToday={summaryTicketTodayData}
                datalabels={datalabels}
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
